
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DOMProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to get a JSON representation of the the UI of the widget
 */
define([], () => {
	class DOMProviderAPI {

		/**
		 * @function DOMProviderAPI#getUIJSON
		 * @description get a JSON representation of the the UI of widget
		 * @returns {Object} UIJSON A JSON representation of the UI of the widget
         */
		getUIJSON() {}

	}

	return DOMProviderAPI;
});
